import popupController from '../popup-controller';
import {FavouriteVacancyDeleteHandler} from '../../vacancy/favourite-vacancy-delete-handler';
import {FavouriteVacancyAddHandler} from '../../vacancy/favourite-vacancy-add-handler';

class PopupFavouriteToggle {
    options = {
        isFavouriteAttribute: 'data-favourite',
        actionUriAttribute: 'data-action-uri',
        deleteUriAttribute: 'data-delete-uri',
        toggleClassname: '-favourite',
    };

    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.element = element;
        this.onClick = this.onClick.bind(this);
    }

    setup() {
        this.attachEventListeners();
    }

    destroy() {
        this.detachEventListeners();
        this.element = null;
    }

    attachEventListeners() {
        this.element.addEventListener('click', this.onClick);
    }

    detachEventListeners() {
        this.element.removeEventListener('click', this.onClick);
    }

    /**
     * @param {MouseEvent} e
     */
    onClick(e) {
        e.preventDefault();

        if (this.isFavourite()) {
            this.handleRemoveFromFavourites();
        } else {
            this.handleAddToFavourites();
        }
    }

    isFavourite() {
        return this.element.hasAttribute(this.options.isFavouriteAttribute);
    }

    async handleAddToFavourites() {
        const handler = new FavouriteVacancyAddHandler(popupController.getPopup());
        const success = await handler.addToFavourites(
            this.element.getAttribute(this.options.actionUriAttribute)
        );
        if (success) {
            this.element.classList.add(this.options.toggleClassname);
            this.element.setAttribute(this.options.isFavouriteAttribute, '');
        }
    }

    async handleRemoveFromFavourites() {
        const handler = new FavouriteVacancyDeleteHandler(popupController.getPopup());
        const success = await handler.removeFromFavourites(
            this.element.getAttribute(this.options.deleteUriAttribute)
        );
        if (success) {
            this.element.classList.remove(this.options.toggleClassname);
            this.element.removeAttribute(this.options.isFavouriteAttribute);
        }
    }
}

export default function (element) {
    const instance = new PopupFavouriteToggle(element);
    instance.setup();
    return instance;
}
